import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { BlockModuleOverviewComponent } from '@app/components/blocks/block-module-overview/block-module-overview.component';
import { PlIconModule } from '@app/icon-library/lib/pl-icon.module';

@NgModule({
  imports: [CommonModule, SharedModule, PlIconModule],
  declarations: [BlockModuleOverviewComponent],
  exports: [BlockModuleOverviewComponent],
})
export class BlockModuleOverviewModule {}
